import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { GalleryImage } from './gallery-image';

// Mock data source -- swap the body of getImages() for an HttpClient
// call against a real API/CMS later; GalleryImage is the contract
// the component depends on, not this file.
const MOCK_IMAGES: GalleryImage[] = [
  {
    id: '1',
    thumbUrl: '/images/gallery/06380fc0-0b7e-4d82-b189-622739d93750.jpeg',
    fullUrl: '/images/gallery/06380fc0-0b7e-4d82-b189-622739d93750.jpeg',
    caption: 'Bulls Barber',
  },
  {
    id: '2',
    thumbUrl: '/images/gallery/3301ce3f-8b1c-4612-a3fe-940d4fce09be.jpeg',
    fullUrl: '/images/gallery/3301ce3f-8b1c-4612-a3fe-940d4fce09be.jpeg',
    caption: 'Bulls Barber',
  },
  {
    id: '3',
    thumbUrl: '/images/gallery/47d24053-55dd-4de7-a268-ebafcfb47810.jpeg',
    fullUrl: '/images/gallery/47d24053-55dd-4de7-a268-ebafcfb47810.jpeg',
    caption: 'Bulls Barber',
  },
  {
    id: '4',
    thumbUrl: '/images/gallery/58724790-54fd-465f-a109-fe79777b9602.jpeg',
    fullUrl: '/images/gallery/58724790-54fd-465f-a109-fe79777b9602.jpeg',
    caption: 'Bulls Barber',
  },
  {
    id: '5',
    thumbUrl: '/images/gallery/6a8ef623-f374-45cb-a12e-14c587c8c95b.jpeg',
    fullUrl: '/images/gallery/6a8ef623-f374-45cb-a12e-14c587c8c95b.jpeg',
    caption: 'Bulls Barber',
  },
  {
    id: '6',
    thumbUrl: '/images/gallery/7b91e72d-74ae-453e-bd0f-c75a22234b8b.jpeg',
    fullUrl: '/images/gallery/7b91e72d-74ae-453e-bd0f-c75a22234b8b.jpeg',
    caption: 'Bulls Barber',
  },
  {
    id: '7',
    thumbUrl: '/images/gallery/9962e695-fbd9-43e2-814a-a0f52bfa3097.jpeg',
    fullUrl: '/images/gallery/9962e695-fbd9-43e2-814a-a0f52bfa3097.jpeg',
    caption: 'Bulls Barber',
  },
  {
    id: '8',
    thumbUrl: '/images/gallery/9ad52bf9-96b0-460c-8ddd-5f25463c94dd.jpeg',
    fullUrl: '/images/gallery/9ad52bf9-96b0-460c-8ddd-5f25463c94dd.jpeg',
    caption: 'Bulls Barber',
  },
  {
    id: '9',
    thumbUrl:
      '/images/gallery/WhatsApp%20Image%202026-08-21%20at%2016.31.16.jpeg',
    fullUrl:
      '/images/gallery/WhatsApp%20Image%202026-08-21%20at%2016.31.16.jpeg',
    caption: 'Bulls Barber',
  },
  {
    id: '10',
    thumbUrl: '/images/gallery/a46cb9b8-77b0-4945-aaa3-1a25ebedef42.jpeg',
    fullUrl: '/images/gallery/a46cb9b8-77b0-4945-aaa3-1a25ebedef42.jpeg',
    caption: 'Bulls Barber',
  },
  {
    id: '11',
    thumbUrl: '/images/gallery/a50c7923-d3d4-4f61-b4a3-854ef08cce6c.jpeg',
    fullUrl: '/images/gallery/a50c7923-d3d4-4f61-b4a3-854ef08cce6c.jpeg',
    caption: 'Bulls Barber',
  },
  {
    id: '12',
    thumbUrl: '/images/gallery/ac9202ac-21fa-40f4-9b02-5c15efd1b302.jpeg',
    fullUrl: '/images/gallery/ac9202ac-21fa-40f4-9b02-5c15efd1b302.jpeg',
    caption: 'Bulls Barber',
  },
  {
    id: '13',
    thumbUrl: '/images/gallery/b6b4c509-d3c3-428e-ad80-1b19afc509a0.jpeg',
    fullUrl: '/images/gallery/b6b4c509-d3c3-428e-ad80-1b19afc509a0.jpeg',
    caption: 'Bulls Barber',
  },
  {
    id: '14',
    thumbUrl: '/images/gallery/c0d48907-ebac-46aa-a07c-1008ee63734d.jpeg',
    fullUrl: '/images/gallery/c0d48907-ebac-46aa-a07c-1008ee63734d.jpeg',
    caption: 'Bulls Barber',
  },
  {
    id: '15',
    thumbUrl: '/images/gallery/d37909b9-b77a-4867-93b9-91cf2958e6a7.jpeg',
    fullUrl: '/images/gallery/d37909b9-b77a-4867-93b9-91cf2958e6a7.jpeg',
    caption: 'Bulls Barber',
  },
  {
    id: '16',
    thumbUrl: '/images/gallery/dfb0c2ac-314a-4493-a1d0-e4ec0255bb17.jpeg',
    fullUrl: '/images/gallery/dfb0c2ac-314a-4493-a1d0-e4ec0255bb17.jpeg',
    caption: 'Bulls Barber',
  },
  {
    id: '17',
    thumbUrl: '/images/gallery/e6c7831f-60f1-4664-a52d-3904df1ca013.jpeg',
    fullUrl: '/images/gallery/e6c7831f-60f1-4664-a52d-3904df1ca013.jpeg',
    caption: 'Bulls Barber',
  },
  {
    id: '18',
    thumbUrl: '/images/gallery/fa99f616-15d9-4a20-ab8c-7f41b1ae79dd.jpeg',
    fullUrl: '/images/gallery/fa99f616-15d9-4a20-ab8c-7f41b1ae79dd.jpeg',
    caption: 'Bulls Barber',
  },
];

@Injectable({
  providedIn: 'root',
})
export class GalleryService {
  getImages(): Observable<GalleryImage[]> {
    return of(MOCK_IMAGES);
  }
}
